import {createEnumType} from 'acscp/api/models/customTypes/enumUtils';

export enum Department {
    COMMJ = 'COMMJ',
    PJETS = 'PJETS',
    Cargo = 'Cargo',
    ACMI = 'ACMI',
}

export const DepartmentType = createEnumType('Department', Department);
